import React from "react";
import imgLogo from "../assets/images/Logo.png";

const Logo = () => {
  return (
    <div className="logo">
      <img src={imgLogo} alt="logo kasa" />
    </div>
  );
};

export default Logo;
